'use client';

import { CMSBlockTitle } from '../cms-block-title';
import { CMSBlockWrapper } from '../cms-block-wrapper';

import css from './seo-text-block-view.css';

import type { SEOTextBlockViewModel } from '../../view-models/blocks/seo-text-block.viewModel';

export function SEOTextBlockView({ body, title }: SEOTextBlockViewModel) {
  return body.processed ? (
    <CMSBlockWrapper>
      {title && <CMSBlockTitle titleTag="h2" value={title} />}
      <div className={css.body} dangerouslySetInnerHTML={{ __html: body.processed }} />
    </CMSBlockWrapper>
  ) : (
    <></>
  );
}
